import { createSlice } from '@reduxjs/toolkit';

export interface LanguageBase {
	code: string;
	priority: number;
}

export interface LanguageInfo extends LanguageBase {
    name: string;
}

export interface LanguageManager extends LanguageBase {
	languages: LanguageInfo[];
}

export interface LanguagesHolder {
  languages:		LanguageInfo[];
}

const initialState: LanguageManager = {
  code:			"",
  priority:		0,
  languages:	[],
};

export const languagesUrl = "/languages.json";

export const languagesSlice = createSlice({
  name: 'languages',
  initialState: {languages: []},
  reducers: {
    assign: (state, action) => {
      state.languages = action.payload.languages;
    },
    setLanguages: (state, action) => {
      state.languages = action.payload;
    },
  },
});

export function copyLanguageInfo(li: LanguageInfo): LanguageInfo {
  return {
    code:					li.code,
    priority:				li.priority,
    name:					li.name,
  };
}

export function copyLanguageInfos(lis: LanguageInfo[]): LanguageInfo[] {
  if (!lis)
    return [];

  return lis.map((li: LanguageInfo) => copyLanguageInfo(li));
}

export function copyLanguagesHolder(holder: LanguagesHolder): LanguagesHolder {
  return {
    languages:			copyLanguageInfos(holder.languages),
  };
}

export function getNewLanguageInfo(): LanguageInfo {
  return {
    name:				"",
    code:				"",
    priority:			0,
  };
}
